export { PageTitle } from './PageTitle'
export type { PageTitleProps } from './PageTitle.types'
